// extracted by mini-css-extract-plugin
export default {"menu":"SectionMenu_menu__pbLBe"};